/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */
import $ from 'jquery';
import { __ } from '@wordpress/i18n';

const vdpPage = $('.vdp-page');
const TEST_PHRASE = 'Heaslip Ford, located in Hagersville';

if (vdpPage.length != 0) {
  window.addEventListener('DOMContentLoaded', function () {
    const $descriptionData = $('.js-trim-text');
    const paragraphs = $descriptionData.data('text');
    const text = paragraphs
      .replace(/<br\s\/>/g, ' @break ')
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim();

    if (!text.includes(TEST_PHRASE)) {
      const $description = $('div[itemprop="description"');
      $description.append(`
            <p>${__(
              "Heaslip Ford, located in Hagersville, Ontario has been Haldimand's longest serving Ford Dealer since 1910. We are known for being one of the oldest Ford dealers in the Dominion of Canada."
            )}</p>

            <p>${__(
              'Positioned to serve Hagersville, and surrounding regions such as Jarvis, Nanticoke, Townsend, Ohsweken, Selkirk, Fisherville, Dunnville as well as Brantford, Hamilton, Port Dover and Simcoe.'
            )}</p>

            <p>${__(
              'To view the latest selection of our new and used inventory, stop by to meet the friendly, experienced, and supportive staff committed to generating a pleasant customer experience.'
            )}</p>

            <p>${__(
              "The following mission statement reflects our Teams positive outlook, and we are here to help you with any of your automotive needs 'At Heaslip Ford, we go the extra distance'."
            )}</p>
            
    `);
    }
  });
}

const rewardsPage = $('.page-template-ford-pass-rewards');
if (rewardsPage.length != 0) {
  const customButton = $('.fpr-custom-button').clone(true, true);
  $('.fpr-custom-button').remove();
  rewardsPage.find('.fpr-hero .section-base').append(customButton);
}
